// envConfig.js

const getDeploymentEnvironment = () => {
    return process.env.REACT_APP_DEPLOYMENT_ENV || 'dev'; // Default to 'development' if the variable is not set
  };
  
  export default getDeploymentEnvironment;
  